// extracted by mini-css-extract-plugin
export var sbShowMain = "blockquote-module--sb-show-main--3WEau";
export var wrapper = "blockquote-module--wrapper--2D0zg";
export var mark = "blockquote-module--mark--2aBce";
export var author = "blockquote-module--author--1yxy0";
export var text = "blockquote-module--text--3cIGv";